import { useEffect, useState } from 'react'

import { Card } from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import { SyndicateServices, IGetFiltroResponse } from 'services/NGT/Syndicate'
import { COLORS, FORMAT, SPACING } from 'utils'
//import { convertBase64 } from "utils/functions"

import { TableActions, FilterTable } from './components'
import EditSyndicateModal from './components/EditSyndicateModal/EditSyndicateModal'
import { useModal, usePersistForm } from 'hooks'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const SCHEMA = yup.object({
  cdCnpj: yup.string().nullable().notRequired(),
  nmSindicato: yup.string().nullable().notRequired()
})

export interface SyndicateSearchFormProps {
  cdCnpj: string
  nmSindicato: string
}

export const SearchSyndicate = () => {
  const { loading, msgErro, setLoading, setMsgErro } = useLoading()
  const [openSyndicateEditModal, toggleSyndicateEditModal] = useToggle()
  const [isDeleteModalOpen, toggleDeleteModal] = useToggle()
  const [page, setPage] = useState<number>(0)
  const [listSyndicates, setListSyndicates] = useState<IGetFiltroResponse[]>([])
  const [selectedSyndicate, setSelectedSyndicate] = useState<any>()
  const [idSyndicateDel, setIdSyndicateDel] = useState<number | undefined>()

  const { showModal } = useModal()

  const { control, watch, setValue, handleSubmit, reset } = useForm<SyndicateSearchFormProps>({ resolver: yupResolver(SCHEMA) })

  usePersistForm('ngt_syndicate_search', {
    setValue,
    watch
  })

  const getSyndicateFilterData = (form: SyndicateSearchFormProps = {} as SyndicateSearchFormProps) => {
    setLoading('loading')

    const requestQUERY: any = {
      cdCnpj: FORMAT.unMask(form.cdCnpj),
      nmSindicato: form.nmSindicato
      //txTipo: tipoState,
    }

    SyndicateServices()
      .getFiltro(requestQUERY)
      .then(({ data }) => {
        setListSyndicates(data)
        setPage(0)
        setLoading('idle')
      })
      .catch((err) => {
        // setMsgErro(err)
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleClearData = () => {
    setSelectedSyndicate({
      cdCep: '',
      cdCnpj: '',
      idSindicato: 0,
      nmBairro: '',
      nmSindicato: '',
      nuNumero: '',
      sgEstado: '',
      sgPais: '',
      txCidade: '',
      txComplemento: '',
      txEndereco: '',
      txObservacao: ''
    })
  }

  const handleUpdateSyndicate = async (requestData: any) => {
    setLoading('loading')
    /*
    const fileBase64 =
      (await requestData.files.length) > 0
        ? convertBase64(requestData.files[0])
        : " "
    */

    const syndicateData = {
      ...requestData,
      cdCep: FORMAT.unMask(requestData.cdCep),
      cdCnpj: FORMAT.unMask(requestData.cdCnpj)
      //dtAnexo: new Date(),
      //txFilePath: fileBase64 as string,
      //txFilename: requestData.files.length > 0 ? (requestData.files[0] as File).name : "",
    }
    //delete syndicateData.files

    SyndicateServices()
      .patch(syndicateData)
      .then(() => {
        setLoading('idle')
        toggleSyndicateEditModal()
        getSyndicateFilterData(watch())
      })
      .catch((error) => {
        // setMsgErro(
        //   error?.response?.data?.title || 'Erro ao gravar as alterações!'
        // )
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error?.response?.data?.title || 'Erro ao gravar as alterações!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleDeleteSyndicate = () => {
    toggleDeleteModal()
    setLoading('loading')
    SyndicateServices()
      .del(idSyndicateDel)
      .then(({ data }) => {
        if (data?.sucesso) {
          getSyndicateFilterData(watch())
        }
        setLoading('idle')
      })
      .catch((err) => {
        // setMsgErro(err?.response?.data?.detail)
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: err?.response?.data?.detail,
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }


  const handleSelectedSyndicate = (currentSyndicate) => {
    handleClearData()
    setLoading('loading')
    SyndicateServices()
      .get(currentSyndicate.idSindicato)
      .then(({ data }) => {
        setSelectedSyndicate(data)
        setLoading('idle')
        toggleSyndicateEditModal()
      })
      .catch(() => {
        // setMsgErro('Erro ao carregar dados do Sindicato!')
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao carregar dados do Sindicato!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleOpenDeleteModal = (idSyndicate: number) => {
    toggleDeleteModal()
    setIdSyndicateDel(idSyndicate)
  }

  const handleClearFilters = () => {
    reset()
    getSyndicateFilterData(watch())

  }

  useEffect(() => {
    getSyndicateFilterData(watch())
  }, [])


  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <FilterTable
          control={control}
          handleSubmit={handleSubmit}
          handleSearchSyndicate={getSyndicateFilterData}
          handleClearFilters={handleClearFilters}
        />
        <TableActions
          setPageNumber={setPage}
          pageNumber={page}
          listRow={listSyndicates}
          handleDeleteSyndicate={handleOpenDeleteModal}
          handleEditSyndicate={handleSelectedSyndicate}
        />
      </Card>
      <EditSyndicateModal
        showEditModal={openSyndicateEditModal}
        toggleModal={toggleSyndicateEditModal}
        syndicateDataTable={selectedSyndicate}
        handleSubmitUpdate={handleUpdateSyndicate}
        handleClearFilters={handleClearFilters}
      />
      <SuccessModal
        open={loading === 'error'}
        message={msgErro}
        type="error"
        hideButtonCancel
        handleConfirm={() => setLoading('idle')}
        txtButtonConfirm="Voltar"
      />
      <SuccessModal
        open={isDeleteModalOpen}
        message="Confirma exclusão (S/N)?"
        type="alert"
        txtButtonCancel="NÃO"
        txtButtonConfirm="SIM"
        handleCancel={toggleDeleteModal}
        handleConfirm={handleDeleteSyndicate}
      />
    </>
  )
}
